export const getMarketingCookies = () => {
	const marketingValues = {
		...getMarketingParamsFromCookies(),
		...getMarketingParamsFromUrl(),
	};

	return JSON.stringify(marketingValues);
};


const getMarketingParamsFromUrl = () => {
	const tracking = {};
	const urlParams = new URLSearchParams(window.location.search);

	const clickIdParams = ['gclid', 'msclid', 'fbclid', 'campaign'];
	clickIdParams.forEach((param) => {
		if (urlParams.has(param)) {
			tracking[param] = urlParams.get(param);
		}
	});

	urlParams.forEach((value, key) => {
		if (key.startsWith('utm_') || key.startsWith('trk_')) {
			tracking[key] = value;
		}
	});

	return tracking;
};


const getMarketingParamsFromCookies = () => {
	return {
		...filterMarketingParams(getAllCookies()),
	};
};

const getAllCookies = () => {
	const cookies = {};
	const cookieParts = document.cookie.split(';');
	let i;

	let name_value = [];
	for (i = 0; i < cookieParts.length; i++) {
		try {
			name_value = cookieParts[i].split('=');
			// Strip the space that may be around the semicolon
			name_value[0] = name_value[0].replace(/^ /, '');
			cookies[decodeURIComponent(name_value[0])] = decodeURIComponent(name_value[1]);
		} catch (e) {
			// Ignore
		}
	}
	return cookies;
};




const filterTracking = (source) => {
	const tracking = {};
	const patterns = [
		'^utm_', // ^ means starts with
		'^trk_',
		'^fbclid',
		'^_fbp$', // $ means ends with
		'^_fbc$',
		'^campaign$',
		'^ptcode$',
		'^aff_trk_',
	];
	let i;
	let re;

	for (const item in source) {
		for (i = 0; i < patterns.length; i++) {
			re = new RegExp(patterns[i]);

			if (item.match(re)) {
				tracking[item] = source[item];
				break;
			}
		}
	}

	return tracking;
};


const filterMarketingParams = (source) => {
	const marketing = {};
	const patterns = [
		'^utm_', // ^ means starts with - any utm parameter
		'^trk_', // any trk parameter
		'^campaign$', // exact match for campaign
		'^gclid$', // exact match for gclid
		'^msclid$', // exact match for msclid
		'^fbclid$', // exact match for fbclid
	];
	let i;
	let re;

	for (const item in source) {
		for (i = 0; i < patterns.length; i++) {
			re = new RegExp(patterns[i]);

			if (item.match(re)) {
				marketing[item] = source[item];
				break;
			}
		}
	}

	return marketing;
};


export const buildPolarisRedirectUrl = (url) => {
	const params = new URLSearchParams();
	params.set('su', 'polaris');

	if (url) {
		params.set('redirect_uri', `${encodeURIComponent(url)}&token=`);
	}

	return `${window.location.origin}/polaris/redirect/?${params.toString()}`;
};


export function getSessionId() {
	return QS.getValue('sessionId') || getAllCookies()['bes-token'] || '';
}


		function getLocationInteraction() {
			try {
				const locationFromLocaleStorage = localStorage.getItem('slf-location');
				const parsedLocationFromLocaleStorage = JSON.parse(locationFromLocaleStorage);
				var locationInteraction = {
					name: parsedLocationFromLocaleStorage.location.name,
					id: parsedLocationFromLocaleStorage.location.id,
					type: parsedLocationFromLocaleStorage.location.type,
				};
				return locationInteraction;
			} catch (error) {
				console.error('Error parsing location from localStorage:', error);
				// Fallback to query string if localStorage fails
				return {
					name: QS.getValue('location') || '',
					id: QS.getValue('locationId') || '',
					type: QS.getValue('locationType') || '',
				};
			}
		}

		function getFiltersFromLocalStorage() {
			try {
				const filtersFromLocaleStorage = localStorage.getItem('slf-filters');
				const parsedFiltersFromLocaleStorage = JSON.parse(filtersFromLocaleStorage ?? {});
				return parsedFiltersFromLocaleStorage;
			} catch (error) {
				return {};
			}
		}

		export function getBackLinkWithQueryParams(backLink, additionalQueryParams) {
			let searchParams = new URLSearchParams(window.location.search).toString();
			if (additionalQueryParams) {
				const queryParamsString = new URLSearchParams(additionalQueryParams).toString();
				searchParams += `&${queryParamsString}`;
			}
			return `${backLink}${searchParams ? `?${searchParams}` : ''}`;
		}

		export function buildInteractionSolutionUrl(data, path) {
			const consumerFrontendUrl = window.Bark.ENV.consumer_frontend_url;

			const searchID = localStorage.getItem('search_id') || QS.getValue('searchID');
			const category = {
				category_name: QS.getValue('categoryName'),
				category_slug: QS.getValue('category_slug'),
				category_id: QS.getValue('categoryId'),
			};

			const locationInteraction = getLocationInteraction();

			const queryParamsObj = {
				project: JSON.stringify({
					seller_profile_id: data.spid.toString(),
					country_id: window.Bark.ENV.ccid.toString(),
					category_slug: category.category_slug,
					category_id: category?.category_id?.toString(),
					location_id: locationInteraction?.id.toString(),
					location_name: locationInteraction?.name?.toString() ?? undefined,
					location_type: locationInteraction?.type?.toString() ?? undefined,
					seller_user_id: data.userId.toString(),
					alid_phy: QS.getValue('trk_alid_phy'),
					alid_int: QS.getValue('trk_alid_int'),
				}),
				trk: JSON.stringify({
					search_id: searchID,
					marketing_tracking: getMarketingCookies(),
					session_id: getSessionId(),
				}),
				filters: JSON.stringify(getFiltersFromLocalStorage()),
				return_url: getBackLinkWithQueryParams(window.location.pathname),
			};

			const params = new URLSearchParams(queryParamsObj);
			params.set(
				'web_hostname',
				window.location.hostname.endsWith('/')
					? window.location.hostname.slice(0, -1)
					: window.location.hostname,
			);

			return `${consumerFrontendUrl}/${path}?${params.toString()}`;
		}